import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle, useUISize } from 'app/utils/web-helpers';
import * as React from 'react';
import { PresentCommunityScreen as PresentCommunityScreenLarge } from './present-community.large';
import { PresentCommunityScreen as PresentCommunityScreenSmall } from './present-community.small';

export { CongratulationComponent, StepName, useAnimationStyle } from './present-community-shared';

export const PresentCommunityScreen: NavigationScreen<'presentCommunity'> = (props) => {
  const { isSmallUI } = useUISize();

  const setPageTitle = usePageTitle('presentCommunity');
  React.useEffect(() => setPageTitle('headerTitle'), [setPageTitle]);

  if (isSmallUI) {
    return <PresentCommunityScreenSmall {...props} />;
  }
  return <PresentCommunityScreenLarge {...props} />;
};
